export default __webpack_public_path__ + "static/icon-linkedin-alt-e8a66a6ff68d5cd906dbd7fc481b15a8.svg";